// extracted by mini-css-extract-plugin
export default {"dashboard_container":"dashboard_container___gvfeF","scroll_bar":"scroll_bar___t1VeZ","social_share":"social_share___FoSKa","social_button":"social_button___ZzbkE"};